import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { exponentialRetryDelay } from '@/lib/react-query/exponentialRetryDelay';
import { prescreenEndpoints } from '@/modules/prescreen/constants';
import {
  createPrescreenCallStartedRequest,
  type RecordPrescreenCallStartedInput,
  shouldRetryPrescreenCallStarted,
} from '@/modules/prescreen/utils/prescreenCallStarted';

export const useTrackPrescreenCallStartedMutation = () =>
  useMutation({
    mutationFn: (input: RecordPrescreenCallStartedInput) =>
      fetchClient.POST(
        prescreenEndpoints.callStarted,
        createPrescreenCallStartedRequest(input),
      ),
    retry: shouldRetryPrescreenCallStarted,
    retryDelay: (attemptIndex) => exponentialRetryDelay(attemptIndex, 3000),
  });
